import { MixpanelPolicyPayload } from './generic-entity-types';

export interface BeneficiariesUpdatedPayload extends MixpanelPolicyPayload {}

export function generateBeneficiariesUpdatedProperties(
  payload: BeneficiariesUpdatedPayload,
): BeneficiariesUpdatedPayload {
  return payload;
}
